module.exports = __webpack_public_path__ + "img/3.94bbd4dc.svg";